export const fetchAvailableSlide = resp => {
  return {
    type: "FETCH_SLIDES_LIST",
    payload: resp
  };
};
export const setSlideListPaginationPage = pageNumber => {
  return {
    type: "SET_SLIDES_LIST_PAGINATION_PAGE",
    pageNumber
  };
};
export const setSlideSelectedItem = selected => {
  return {
    type: "SET_SLIDES_SELECTED_ITEM",
    selected
  };
};
export const setSlideListPageSize = pageSize => {
  return {
    type: "SET_SLIDES_LIST_PAGE_SIZE",
    pageSize
  };
};
export const setSlideListFilterTitle = title => {
  return {
    type: "SET_SLIDES_LIST_FILTER_TITLE",
    title
  };
};
export const deleteSlide = resp => {
  return {
    type: "DELETE_SLIDE",
    payload: resp
  };
};
export const updatePrivacySlide = resp => {
  return {
    type: "UPDATE_PRIVACY_SLIDE",
    payload: resp
  };
};
export const updateStateSlide = resp => {
  return {
    type: "UPDATE_STATE_SLIDE",
    payload: resp
  };
};
export const duplicateSlide = resp => {
  return {
    type: "DUPLICATE_SLIDE",
    payload: resp
  };
};
export const setSlidesListFilterIndicator = indicators => {
  return {
    type: "SET_SLIDES_FILTER_INDICATORS",
    indicators
  };
};
export const setSlideListFilterStatus = status => {
  return {
    type: "SET_SLIDES_LIST_FILTER_STATUS",
    status
  };
};
export const setSlideListFilterisPublic = (isPublic, operator) => {
  return {
    type: "SET_SLIDES_LIST_FILTER_IS_PUBLIC",
    isPublic,
    operator
  };
};
export const setSlideListFilterNewSlideIds = newSlideIds => {
  return {
    type: "SET_SLIDES_LIST_FILTER_NEW_SLIDE_IDS",
    newSlideIds
  };
};
export const setSlidesListFilter = filterStatus => {
  return {
    type: "SET_SLIDES_FILTER",
    filterStatus
  };
};
export const setIndicatorSuggestions = resp => {
  return {
    type: "FETCH_INDICATOR_SUGGESTIONS",
    payload: resp
  };
};
export const setSlidePrivate = resp => {
  return {
    type: "SET_SLIDE_PRIVATE",
    payload: resp
  };
};
export const useSharedSlide = resp => {
  return {
    type: "USE_SHARED_SLIDE",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/slideList.js